import * as React from "react";
import { AppSpinner } from "@rhc-shared-components/app-spinner";
import { RHCErrorPage } from '@rhc-shared-components/error-page';

const FourNotFour = () => {
    return <RHCErrorPage errorStatus={404}/>;
};

// lazy loaded component registry
export const lazyComponent = {
    MyProfile: React.lazy(()=>import("../../AccountDetails/MyProfile/MyProfile")),
    CompanyProfile: React.lazy(()=>import("../../AccountDetails/CompanyProfile/CompanyProfile")),
    TeamMembers: React.lazy(()=>import("../../AccountDetails/TeamMembers/TeamMembers")),
    Agreements: React.lazy(()=>import("../../AccountDetails/Agreements/Agreements")),
    KeyManager: React.lazy(()=>import("../../AccountDetails/KeyManager/KeyManager")),
    DashboardContainer: React.lazy(()=>import("../../Dashboard/DashboardContainer")),
    BuildPartnerOnboarding: React.lazy(()=>import("../../BuildPartnerOnboarding/BuildPartnerOnboarding")),
    FourOhFour: React.lazy(()=>Promise.resolve({ default: FourNotFour })),
}
export type LazyComponentName = keyof typeof lazyComponent;

export interface ComponentLoaderProps {
    componentName: LazyComponentName;
}

const ComponentLoader: React.FC<ComponentLoaderProps> = ({ componentName }) => {
    const Component = lazyComponent[componentName] || lazyComponent['FourOhFour'];

    return (
        <React.Suspense fallback={<AppSpinner />}>
            <Component />
        </React.Suspense>
    );
};

export default ComponentLoader;
